import { CUSTOM } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'custom_11',
  type: CUSTOM,
  name: 'Custom with image cards',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/custom/custom_11.png',
  rootContent: {
    type: contentTypes.ROW,
    properties: {
      fontWeight: {type: 'css', value: 'bold'},
      padding: {type: 'css', value: '2rem'},
      display: {type: 'css', value: 'flex'},
      justifyContent: {type: 'css', value: 'center'},
      backgroundImage: {type: 'css', value: 'linear-gradient(180deg,rgba(95,158,196,1) 35%, rgba(106,184,194,1) 100%)', editable:true}
    },
    contents: [
      {
        type: contentTypes.COLUMN,
        properties: {
          large: {type: 'responsive', value: 4},
          medium: {type: 'responsive', value: 9},
          small: {type: 'responsive', value: 10},
          padding: {type: 'css', value: 0},
          margin: {type: 'css', value: 0}

        },
        contents: [
          {
            type: contentTypes.TEXT,
            value: 'Lorem Ipsum is simply dummy',
            properties: {
              color: {type: 'css', value: 'white',editable:true},
              padding: {type: 'css', value: '2rem 1rem 2rem 0'},
              fontWeight: {type: 'css', value: 'bold'},
              fontSize: {type: 'css', value: '26px'}
            },
          },
          {
            type: contentTypes.TEXT,
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat..',
            properties: {
              padding: {type: 'css', value: '0 1rem 2rem 0'},
              color: {type: 'css', value: 'white',editable:true},
              fontWeight: {type: 'css', value: 'normal'},
              fontSize: {type: 'css', value: '18px'},
              lineHeight: {type: 'css', value: '1.6'},

            },
          }
        ]
      },
      {
        type: contentTypes.COLUMN,
        properties: {
          large: {type: 'responsive', value: 4},
          medium: {type: 'responsive', value: 9},
          small: {type: 'responsive', value: 10},
          padding: {type: 'css', value: 0},
          margin: {type: 'css', value: 0}
        },
        contents: [
          {
            type: contentTypes.TEXT,
            value: 'Lorem Ipsum is simply dummy',
            properties: {
              color: {type: 'css', value: 'white',editable:true},
              padding: {type: 'css', value: '2rem 1rem 2rem 0'},
              fontWeight: {type: 'css', value: 'bold'},
              fontSize: {type: 'css', value: '26px'}
            },
          },
          {
            type: contentTypes.TEXT,
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat..',
            properties: {
              padding: {type: 'css', value: '0 1rem 2rem 0'},
              color: {type: 'css', value: 'white',editable:true},
              fontWeight: {type: 'css', value: 'normal'},
              fontSize: {type: 'css', value: '18px'},
              lineHeight: {type: 'css', value: '1.6'},

            },
          }
        ]
      },
      {
        type: contentTypes.COLUMN,
        properties: {
          large: {type: 'responsive', value: 4},
          medium: {type: 'responsive', value: 9},
          small: {type: 'responsive', value: 10},
          padding: {type: 'css', value: 0},
          margin: {type: 'css', value: 0}
        },
        contents: [
          {
            type: contentTypes.TEXT,
            value: 'Lorem Ipsum is simply dummy',
            properties: {
              color: {type: 'css', value: 'white',editable:true},
              padding: {type: 'css', value: '2rem 1rem 2rem 0'},
              fontWeight: {type: 'css', value: 'bold'},
              fontSize: {type: 'css', value: '26px'}
            },
          },
          {
            type: contentTypes.TEXT,
            value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat..',
            properties: {
              padding: {type: 'css', value: '0 1rem 2rem 0'},
              color: {type: 'css', value: 'white',editable:true},
              fontWeight: {type: 'css', value: 'normal'},
              fontSize: {type: 'css', value: '18px'},
              lineHeight: {type: 'css', value: '1.6'},

            },
          }
        ]
      },
      {
        type: contentTypes.COLUMN,
        properties: {
          large: {type: 'responsive', value: 2},
          medium: {type: 'responsive', value: 9},
          small: {type: 'responsive', value: 10},
          offsetMedium: {type: 'responsive', value: 4},
          padding: {type: 'css', value: 0},
          margin: {type: 'css', value: '2rem 1rem 2rem 1rem'},
        },
        contents: [

          {
            type: contentTypes.TEXT,
            value: 'Contact Us',
            properties: {
              margin: {type:'css', value: '0 1rem 0 1rem'},
              linkColor: {type: 'css', value: 'white', editable: true},
              color: {type: 'css', value: '#408EA7', editable: true},
              fontWeight: {type: 'css', value: 'normal'},
              padding: {type: 'css', value: '0.6rem 1rem 0.6rem 0'},
              textAlign: {type: 'css', value: 'center'},
              minHeight: {type: 'css', value: '2rem'},
              lineHeight: {type: 'css', value: '2rem'},
              backgroundColor: {type: 'css', value: 'white',editable:true},
              width: {type:'css', value: '10rem'},
              borderRadius: {type: 'css', value: '35px'},
              fontSize: {type: 'css', value: '20px'}
            }
          }
        ]
      },





    ]
  }
}
